import { Box } from '@mui/material';
import InputMask from 'react-input-mask';
import { KitField, KitInput, KitSelect, KitTextarea } from './MobileKitExtras';

/**
 * Campo de formulário mobile ligado ao Formik: `.field` (rótulo 11/800 + ajuda/erro) com
 * `.input`, `.select` ou `.textarea` do protótipo. Só apresentação — valores e validação
 * continuam no `useFormik` da tela.
 *
 * `as`: 'input' (padrão) | 'select' | 'textarea'. `mask` usa react-input-mask (como Clientes).
 */
export default function FkField({
    formik,
    name,
    label,
    required,
    help,
    as = 'input',
    mask,
    onChange,
    onBlur,
    wrap,
    sx,
    children,
    ...inputProps
}) {
    const errorText = (formik.touched[name] && formik.errors[name]) || '';
    const error = Boolean(errorText);
    const value = formik.values[name] ?? '';
    const handleChange = onChange || formik.handleChange;

    let control;
    if (as === 'select') {
        control = (
            <KitSelect name={name} value={value} onChange={handleChange} onBlur={onBlur} sx={error ? { borderColor: 'error.main', ...sx } : sx} {...inputProps}>
                {children}
            </KitSelect>
        );
    } else if (as === 'textarea') {
        control = (
            <KitTextarea name={name} value={value} onChange={handleChange} onBlur={onBlur} sx={error ? { borderColor: 'error.main', ...sx } : sx} {...inputProps} />
        );
    } else if (mask) {
        control = (
            <InputMask mask={mask} value={value} onChange={handleChange} onBlur={onBlur} disabled={inputProps.disabled}>
                {(maskProps) => <KitInput {...maskProps} name={name} error={error} sx={sx} {...inputProps} />}
            </InputMask>
        );
    } else {
        control = <KitInput name={name} value={value} onChange={handleChange} onBlur={onBlur} error={error} sx={sx} {...inputProps} />;
    }

    return (
        <KitField label={label} required={required} help={errorText || help} error={error}>
            {wrap ? wrap(control) : control}
        </KitField>
    );
}

// Link de atalho abaixo do campo (`+ Nova categoria`) — extra do app real.
export function FkInlineLink({ label, onClick, disabled }) {
    return (
        <Box
            component="button"
            type="button"
            onClick={onClick}
            disabled={disabled}
            sx={{ display: 'inline-flex', alignItems: 'center', gap: '4px', mt: '6px', p: 0, border: 0, background: 'none', fontFamily: 'inherit', fontSize: 12, fontWeight: 700, color: 'primary.main', cursor: 'pointer', '&:disabled': { opacity: 0.45, cursor: 'default' } }}
        >
            + {label}
        </Box>
    );
}
